import React from "react";
import "./Header.scss";

import { motion } from "framer-motion";
import { images } from "../../constants";
import {AppWrap} from "../../wrapper";


const Header = () => {
  return (
      <div className="app__header app__flex">
      <motion.div className="app__header_info" whileInView={{ x: [-100, 0], opacity: [0, 1] }} transition={{ duration: 0.5 }}>
        <div className="app__header-badge">
          
          <div data-scroll data-scroll-direction="horizontal" data-scroll-speed="1" className="badge-cmp app__flex">
              <h1 data-scroll data-scroll-direction="horizontal" data-scroll-speed="-5" className="head-text-name" style={{color: 'white'}}>Aspiring Frontend Developer</h1>
          </div>

          <div data-scroll data-scroll-direction="vertical" data-scroll-speed="-1.2" className="tag-cmp app__flex">
            <p className="p-text" style={{color: '#00EBE6'}}>
            Hi, I'm Abinash. I'm passsionate all things about JavaScript. I work hard, I care about writing clean code and I genuninly love to learn. I'm currently looking to work in an environment that will help me to grow as a developer.
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div className="app__header_img" data-scroll data-scroll-direction="vetical" data-scroll-speed="3" whileInView={{opacity: [0, 1] }} transition={{ duration: 0.5, delayChildren: 0.5 }}  >
        <img src={images.profile} alt="profile-bg" />
      </motion.div>
    </div>
  );
};

export default AppWrap(Header, 'home');
